if (!customElements.get('ly-main-cart-items-content-form-item-set-primary-media-model-viewer')) {
    customElements.define('ly-main-cart-items-content-form-item-set-primary-media-model-viewer', class extends LyModelViewerBase {

        async connectedCallback() {
            super.connectedCallback()

            const script = this.querySelector('script[type="application/json"][data-model-config]')
            this.modelConfig = readJsonFromScript(script)

            await this._initBase()

            this._requestRender('infinity')

            this.loadModels()
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        /** 渲染前钩子：用于执行每帧的旋转动画 */
        _beforeRender = () => {
            if (this._rootGroup) {
                this._rootGroup.rotation.y += 0.005
            }
        }

        _initOrbitController = () => { }

        loadModels = () => {
            this._rootGroup.position.y = -1
            Object.values(this.modelConfig).forEach(config => {
                this.loadGltf(config)
            })
        }

        /** 加载模型 */
        loadGltf = async ({ url, transform, materialConfig }) => {
            let gltf
            try {
                gltf = await this._loadGltf(url)

                const model = gltf.scene

                this._rootGroup.add(model)

                this._applyTransform(gltf, transform)
                this._applyMaterial(gltf, materialConfig)

                return gltf
            } catch (error) {
                this._disposeObject3D(gltf.scene)
                throw error
            }
        }
    })
}